import { render } from "./leadingcompanies.vue?vue&type=template&id=57db7a54"
import script from "./leadingcompanies.vue?vue&type=script&lang=js"
export * from "./leadingcompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__